import { PaymentMethod } from 'api/models';
import { Badge } from 'antd';

const paymentMethodBadgeMapping: Record<PaymentMethod, { color: string; label: string }> = {
  [0]: {
    // Cash
    color: 'green',
    label: 'Cash',
  },
  [1]: {
    // Bank
    color: 'blue',
    label: 'Bank',
  },
  [2]: {
    // Crypto
    color: 'purple',
    label: 'Crypto',
  },
  [3]: {
    // Other
    color: 'default',
    label: 'Other',
  },
};

const renderPaymentMethodBadge = (method: PaymentMethod) => {
  const badgeInfo = paymentMethodBadgeMapping[method];

  if (!badgeInfo) return null;

  return (
    <Badge className={`ant-badge badge badge-${badgeInfo.color}`} color={badgeInfo.color} count={badgeInfo.label} />
  );
};

export default renderPaymentMethodBadge;
